module.exports = __webpack_public_path__ + "img/other_normal.dd2327a0.png";